<template>
    <div class="page-container">
        <EquiType @change="handleChangeType" @updateForm="getEquipTypeOptionListsData" />
        <div class="data-container">
            <div class="tool-box">
                <el-button type="primary" :icon="Plus" @click="onAddClick" v-permission="['equip:model:add']">添加</el-button>
                <el-button @click="uploadVisible = true" :icon="Upload" v-permission="['equip:model:import']">导入</el-button>
                <el-button @click="handleExport" :icon="Download" v-permission="['equip:model:export']">导出</el-button>
                <el-button :icon="DCaret" v-permission="['equip:model:sort']" @click="handleSort">一键排序</el-button>
            </div>
            <el-form
                class="search-form"
                v-if="formVisible"
                :inline="true"
                :model="queryForms"
                label-position="top"
                style="padding: 0 20px"
            >
                <el-form-item label="型号编码">
                    <el-input style="width: 200px" v-model="queryForms.code" clearable placeholder="请输入型号编码" />
                </el-form-item>
                <el-form-item label="型号名称">
                    <el-input style="width: 200px" placeholder="请输入型号名称" v-model="queryForms.name" clearable />
                </el-form-item>
                <el-form-item label="品牌名称">
                    <el-select v-model="queryForms.brand" placeholder="请选择品牌名称" clearable>
                        <el-option v-for="item in brandOptionList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="通信类型" v-if="isSystemAdmin">
                    <el-select v-model="queryForms.comm_type" placeholder="请选择通信类型" style="width: 200px" clearable>
                        <el-option
                            v-for="item in commTypeList"
                            :key="item.value"
                            :label="item.name"
                            :value="Number(item.value)"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :icon="Search" @click="getTableData">搜索</el-button>
                    <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
                </el-form-item>
            </el-form>
            <el-table
                class="data-table"
                :data="table_data"
                v-loading="tableLoading"
                row-key="id"
                :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            >
                <el-table-column label="序号" width="100" type="index" />
                <el-table-column label="型号名称" min-width="150" prop="name"></el-table-column>
                <el-table-column label="型号编码" min-width="150" prop="code"></el-table-column>
                <el-table-column label="设备类型" prop="type">
                    <template #default="{ row }">
                        <span>{{ equipTypeOptionObj[row.type] }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="品牌名称" prop="brand_name">
                    <template #default="{ row }">
                        <span>{{ row.brand_name ? row.brand_name : '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="品牌编码" prop="brand_code">
                    <template #default="{ row }">
                        <span>{{ row.brand_code ? row.brand_code : '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="通信类型" prop="type" v-if="isSystemAdmin">
                    <template #default="{ row }">
                        <span>{{ commTypeObj[row?.comm_type] }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="高功率kw/h" prop="high_power"></el-table-column>
                <el-table-column label="中功率kw/h" prop="mid_power"></el-table-column>
                <el-table-column label="低功率kw/h" prop="low_power"></el-table-column>
                <el-table-column prop="list_order" label="排序" width="110" align="center">
                    <template #default="{ row }">
                        <span v-if="!isSystemAdmin && row.preset">{{ row.list_order }}</span>
                        <el-input-number
                            v-else
                            style="width: 80px"
                            type="number"
                            v-model="row.list_order"
                            :min="0"
                            :max="999999"
                            controls-position="right"
                            size="small"
                        />
                    </template>
                </el-table-column>
                <el-table-column label="预设" width="80" align="center" prop="preset">
                    <template #default="{ row }">
                        <span :style="{ color: row?.preset ? '#67C23A' : '#303133' }">{{ row?.preset ? '是' : '否' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="200">
                    <template #default="{ row }">
                        <el-button type="primary" link :icon="View" size="small" @click="onShowClick(row)">详情</el-button>
                        <el-button
                            type="primary"
                            link
                            :icon="Edit"
                            :disabled="!isSystemAdmin && (row?.preset || !row?.school)"
                            size="small"
                            @click="onEditClick(row)"
                            v-permission="['equip:model:edit']"
                        >
                            编辑
                        </el-button>
                        <el-button
                            type="primary"
                            link
                            :icon="Delete"
                            :disabled="!isSystemAdmin && (row?.preset || !row?.school)"
                            size="small"
                            @click="onRemoveClick(row)"
                            v-permission="['equip:model:remove']"
                        >
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                class="pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryForms.page"
                :page-sizes="[10, 20, 50]"
                :page-size="queryForms.page_size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            ></el-pagination>
            <forms-dialog
                v-model="formDialogVisible"
                :isForm="isForm"
                :typeId="selsectTypeId"
                :typeCode="selectType"
                :modelId="selectModelId"
                :equipTypeOptionLists="equipTypeOptionLists"
                :manufacturerOptionLists="manufacturerOptionLists"
                @updateForm="getTableData"
            ></forms-dialog>
            <ImportsForm v-if="uploadVisible" v-model="uploadVisible" menuCode="equipModel" @updateForm="getUploadStatus" />
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { DCaret, Delete, Download, Edit, Plus, Refresh, Search, Upload, View } from '@element-plus/icons'
import { getBrandOption } from '@/api/deviceBrand/deviceBrand'
import { getEquipTypeOptionLists } from '@/api/equipType'
import { batchEquipModel, delEquipModel, getCommunicationType, getEquipModelLists } from '@/api/equipModel'
import FormsDialog from './components/forms.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import ImportsForm from '@/components/ImportsForm.vue'
import EquiType from './components/type.vue'
import { getItem } from '@/utils/storage'

// 是否为系统管理员
const isSystemAdmin = computed(() => getItem('userInfo')?.is_system_admin)

const formVisible = ref(true)
// 重置
const resetQueryForm = () => {
    Object.keys(queryForms.value).forEach((key) => {
        if (key !== 'page' && key !== 'page_size') queryForms.value[key] = ''
    })
}
// 数据源
const queryForms = ref({
    type: '',
    code: '',
    name: '',
    bradn: '',
    comm_type: '',
    page: 1,
    page_size: 10
})
const table_data = ref([])
const tableLoading = ref(true)
const total = ref(0)

// 通信类型
const commTypeList = ref([])
const commTypeObj = ref(null)
const getCommunicationTypeFun = async () => {
    const { comm_type: commType } = await getCommunicationType()
    commTypeObj.value = commType
    for (const item in commType) {
        commTypeList.value.push({
            value: item,
            name: commType[item]
        })
    }
}
getCommunicationTypeFun()

// 设备类型选项列表、厂家选项列表
const equipTypeOptionLists = ref([])
const equipTypeOptionObj = ref({})
const manufacturerOptionLists = ref([])
// 品牌下拉选项
const brandOptionList = ref([])
const getEquipTypeOptionListsData = async () => {
    const res = await getEquipTypeOptionLists()
    const brand = await getBrandOption()
    brandOptionList.value = brand
    equipTypeOptionLists.value = res
    const optionObj = {}
    res.forEach((item) => {
        optionObj[item.id] = item.name
    })
    equipTypeOptionObj.value = optionObj
}

getEquipTypeOptionListsData()

// 获取列表数据
const getTableData = async () => {
    tableLoading.value = true
    const result = await getEquipModelLists(queryForms.value)
    table_data.value = result.lists
    total.value = result.total
    tableLoading.value = false
}

// 分页相关
// page_size 改变触发
const handleSizeChange = (currentSize) => {
    queryForms.value.page_size = currentSize
    getTableData()
}
// page 页码改变触发
const handleCurrentChange = (currentPage) => {
    queryForms.value.page = currentPage
    getTableData()
}

const formDialogVisible = ref(false)
const isForm = ref(false) // 是否是表单
const selectModelId = ref('') // 点中的模块id
// 保证每次打开重新获取数据
watch(formDialogVisible, (val) => {
    if (!val) selectModelId.value = ''
})

// 查看
const onShowClick = (row) => {
    isForm.value = false
    selectModelId.value = row.id
    formDialogVisible.value = true
}
// 编辑
const onEditClick = (row) => {
    isForm.value = true
    selectModelId.value = row.id
    formDialogVisible.value = true
}
// 添加
const onAddClick = () => {
    selectModelId.value = ''
    isForm.value = true
    formDialogVisible.value = true
}

// 删除

const onRemoveClick = (row) => {
    ElMessageBox.confirm('确定要删除 ' + row.name + ' 吗？', {
        type: 'warning'
    })
        .then(async () => {
            if (row.pid == null) {
                await delEquipModel(row.id)
            } else {
                // await delSuper(row.id)
            }
            ElMessage.success('删除成功！')
            // 重新渲染数据
            getTableData()
        })
        .catch(() => {})
}

const uploadVisible = ref(false)
// 导出
const handleExport = async () => {
    ElMessageBox.confirm('您确定导出全部设备型号吗？', {
        type: 'warning'
    })
        .then(async () => {
            const { data } = await getEquipModelLists({ ...queryForms.value, export: 1 })
            window.open(data)
            ElMessage.success('导出成功')
        })
        .catch(() => {})
}

// 获取导入弹框状态,上传成功后刷新
const getUploadStatus = (e) => {
    getTableData()
}

// 所选类型
const selsectTypeId = ref()
const selectType = ref('')
const handleChangeType = (data, type) => {
    queryForms.value.type = data
    selsectTypeId.value = data
    selectType.value = type
    getTableData()
}

// 一键排序
const handleSort = async () => {
    const soreObj = {}
    if (table_data.value.length === 0) return
    table_data.value.forEach((ele) => {
        if (ele.preset) return
        soreObj[ele.id] = ele.list_order
    })
    try {
        await batchEquipModel('batch_update_order', soreObj)
        ElMessage.success('操作成功')
    } catch (error) {}

    getTableData()
}

// 切换到前台时候执行
onMounted(() => {
    getTableData()
})
</script>

<style scoped></style>
